import { CodedError } from './codedError';

export class ResellerSelectionError extends CodedError<ResellerSelectionErrorCode> {}

export type ResellerSelectionErrorCode = 'NoAuthorizedResellers' | 'GetAuthorizedResellersFailed';
